module.exports = __webpack_public_path__ + "static/img/hotelmeister-logo-birthday.d124c46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/png/hotelmeister-logo-birthday.png
// module id = Jgxj
// module chunks = 0